import React from 'react';
import { Box, Button, Grid, Paper, Typography } from '@material-ui/core';
import UnitsVehiclesBlock from './VehiclesBlock';

const VehiclesSection = ({
  title,
  vehicleTitle,
  type,
  buttonId,
  addButtonText,
  addButtonHandler,
  vehicles,
  control,
  register,
  fieldErrors,
  deleteButtonHandler,
  watch,
  getValues,
  formErrors,
  setValue,
  showActions,
  submitDisabled,
  onSavePermit,
  onCancelPermit,
  newPermitIndex,
  isUnitLoaded,
  vehiclesRevision = 0,
}) => {
  const isVehicleRecord = (item) =>
    item && typeof item === 'object' && !Array.isArray(item);
  let vehicleNumber = 0;

  return (
    <>
      <Paper elevation={0} variant="outlined">
        <Box
          p={3}
          display="flex"
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography variant="h5" color="primary">
            {title}
          </Typography>
          {showActions ? (
            <Button
              id={buttonId}
              variant="outlined"
              color="primary"
              onClick={addButtonHandler}
            >
              {addButtonText}
            </Button>
          ) : null}
        </Box>
        {vehicles.length ? (
          <Box px={3} pb={3}>
            <Grid container spacing={2}>
              {vehicles.map((item, index) => {
                if (item === undefined) {
                  return null;
                }

                const cardNumber = ++vehicleNumber;
                const slotKey = item?.id
                  ? `${type}-permit-${item.id}`
                  : `${type}-empty-${vehiclesRevision}-${index}`;

                return (
                  <Grid
                    item
                    xs={12}
                    md={6}
                    lg={4}
                    key={slotKey}
                  >
                    <Paper
                      variant="outlined"
                      style={{
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                      }}
                    >
                      <UnitsVehiclesBlock
                        fieldId={buttonId}
                        vehicleIndex={index}
                        vehicleNumber={cardNumber}
                        vehicleTitle={vehicleTitle}
                        type={type}
                        vehicle={isVehicleRecord(item) ? item : null}
                        control={control}
                        register={register}
                        fieldErrors={fieldErrors}
                        deleteButtonHandler={deleteButtonHandler}
                        watch={watch}
                        getValues={getValues}
                        formErrors={formErrors}
                        setValue={setValue}
                        showActions={showActions}
                        submitDisabled={submitDisabled}
                        isUnitLoaded={isUnitLoaded}
                        startInEditMode={index === newPermitIndex}
                        onSave={() => onSavePermit(index)}
                        onCancel={() => onCancelPermit(index)}
                      />
                    </Paper>
                  </Grid>
                );
              })}
            </Grid>
          </Box>
        ) : null}
      </Paper>
      <Box mb={3} />
    </>
  );
};

export default VehiclesSection;
